import * as React from "react";
import { useIntl } from 'gatsby-plugin-react-intl'
import { graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Layout } from 'components/layout/Layout';
import { DestinationPageHero } from 'components/locations/DestinationPageHero';
import { StatCardsWrapper } from "components/locations/StatCardsWrapper";
import { Chart } from "components/locations/Chart";
import { SunheronFeaturesWrapper } from "components/shared/SunheronFeaturesWrapper";
import { DestinationRecommendationCards } from "components/locations/DestinationRecommendationCards";
import { Gallery } from "components/locations/Gallery";
import { getMonthIndexFromName } from "context/SelectedMonthContext";
import { Region, RegionMonth, RegionBase } from './fragments/region'
import { TextParser } from "components/locations/TextParser";
import getMonthWithPreposition from "services/getMonthWithPreposition";
import LogoIcon from 'images/logo_menu.svg';
import { useElementWidth } from "hooks/useElementWidth";
import firstCapital from 'services/firstCapitalCase'
import { useTemperatureUnitContext } from "context/TemperatureUnitContext";
import textParser from "services/textParser";

type LocationType = {
    data: Query,
    path: string,
    pageContext: { month: string, slug: string }
}

const Location = ({ data, path, pageContext }: LocationType) => {
    const intl = useIntl();
    const [units] = useTemperatureUnitContext()
    let weatherData = data.regionsJson.weatherData;
    const faqs = data.regionsMonthsJson.questions.map((question: string, idx: number) => {
        return { question: question, answer: data.regionsMonthsJson.answers[idx] };
    })
    let weatherOrClimate = pageContext.month == 'all' ? intl.formatMessage({ id: 'common.climate' }) : intl.formatMessage({ id: 'common.weather' })
    let header = `${data.regionsJson.name} ${weatherOrClimate}`
    let similarWeatherHeader = intl.formatMessage({ id: 'common.otherDestinationsWithSimilar' }) + ' ' + data.regionsJson.name;
    header += pageContext.month != 'all' ? ` ${getMonthWithPreposition({ intl, monthAbbreviation: pageContext.month })}` : ''
    const destinationInfoHeader = firstCapital(weatherOrClimate) + ' ' + intl.formatMessage({ id: 'common.overviewAndFaqs' })
    faqs.splice(0, 1, { question: firstCapital(weatherOrClimate) + ' ' + intl.formatMessage({id: 'common.overview'}), answer: data.regionsMonthsJson.header })
    const monthIndex = getMonthIndexFromName(pageContext.month);
    //   const [formattedMonth, setFormattedMonth] = React.useState(formatMonthToBeInAccusative(activeMonth.name.toLowerCase()))
    const scrollRef = React.useRef(null);
    const widthRef = React.useRef(null);
    const [refWidth, setRefWidth] = React.useState(600);
    useElementWidth(widthRef, setRefWidth);
    //   const destinationInfo = data.allLocationsJson.edges[0].node
    //   React.useEffect(()=>{
    //     activeMonth = getActiveMonth(months)
    //     setFormattedMonth(formatMonthToBeInAccusative(activeMonth.name.toLowerCase()))
    //   }, [months])
    //     const pageDescription = 'abce';
    return (<Layout path={path} title={header} faqs={faqs} description={textParser({ text: data.regionsMonthsJson.header, units, noNbsp: true })}>
        <DestinationPageHero
            header={header}
            placeWithPreposition={`${data.regionsJson.name}`}
            month={pageContext.month}
            bgImage={data.regionsJson.heroImg.childImageSharp.gatsbyImageData}
            region={data.regionsJson}
            slug={data.regionsJson.slug}
        />
        {pageContext.month != 'all' && <><StatCardsWrapper
            scrollRef={scrollRef}
            weatherData={weatherData}
            monthIndex={monthIndex}
        /><div className="height--1" /></>
        }
        {pageContext.month == 'all' && <div className="height--3" />}
        {pageContext.month != 'all' && <div className="height--1" />}
        {/* <form>
            <div className="row row--ng">
                <FormSelectComponent
                    initialValue={chartState}
                    options={[
                        { label: 'Rest', value: 'overview' },
                        { label: 'Tmin', value: 'tmin' },
                    ]}
                    id={`chartStateSelect`}
                    onChange={({ value }: { value: string }) => { setChartState(value) }}
                />
            </div>
        </form> */}

        <div className="destination__graph__scrollcontainer">
            <h2 className="text--center destination__info__header margin--auto">{`${intl.formatMessage({ id: 'common.weatherChartFor' })} ${data.regionsJson.name}`}</h2>
            <Chart
                    weatherData={data.regionsJson.weatherData}
                    chartWrapperRefOuter={widthRef}
                    title={refWidth <= 750 ? 'Weather overview' : undefined}
                    fixedMeasures={refWidth > 750 ? null : ['tmax', 'sst', 'ppt', 'tmin']}
                />
            {refWidth <= 750 &&
                <>
                    
                {/* <h3 className="destination__chart__title">{`${firstCapital(intl.formatMessage({ id: 'common.measures.wet' }))} ${intl.formatMessage({ id: 'common.chart' })} - ${data.regionsJson.name}`}</h3> */}
                    <Chart
                    weatherData={data.regionsJson.weatherData}
                    title="Wet days chart"
                        fixedMeasures={['wet']}
                    />
                    {data.regionsJson.weatherData.sunhrs[0] && <>
                    {/* <h3 className="destination__chart__title">{`${firstCapital(intl.formatMessage({ id: 'common.measures.sunhrs' }))} ${intl.formatMessage({ id: 'common.chart' })} - ${data.regionsJson.name}`}</h3> */}
                        <Chart
                        weatherData={data.regionsJson.weatherData}
                        title="Sunhours chart"
                            fixedMeasures={['sunhrs']}
                        />
                    </>}

                    {data.regionsJson.weatherData.ws[0] && <>
                    {/* <h3 className="destination__chart__title">{`${firstCapital(intl.formatMessage({ id: 'common.measures.ws' }))} ${intl.formatMessage({ id: 'common.chart' })} - ${data.regionsJson.name}`}</h3> */}
                        <Chart
                        weatherData={data.regionsJson.weatherData}
                        title="Wind speed chart"
                            fixedMeasures={['ws']}
                        />
                    </>}

                    {data.regionsJson.weatherData.rhm[0] && <>
                    {/* <h3 className="destination__chart__title">{`${firstCapital(intl.formatMessage({ id: 'common.measures.rhm' }))} ${intl.formatMessage({ id: 'common.chart' })} - ${data.regionsJson.name}`}</h3> */}
                        <Chart
                        weatherData={data.regionsJson.weatherData}
                        title="Humidity chart"
                            fixedMeasures={['rhm']}
                        />
                    </>}
                </>
            }
        </div>
        <SunheronFeaturesWrapper />
        

        {/* { <DestinationRecommendationCards title={`Kam se v dubnu v ${destinationInfo.czech.title} vydat`} querySlice={[2,10]}/> */}
        <Gallery galleryPhotos={data.regionsJson.imgs.map(i => i.childImageSharp.gatsbyImageData)} />
        <div className="height--2" />
        {/* {Place for affiliate links - link cards} */}
        <h2 className="text--center destination__info__header margin--auto">
            {destinationInfoHeader}
        </h2>
        <div className="destination__info">
            
            {faqs.map((faq: { question: string, answer: string }, index: number) => {
                return (<div key={index}>
                    <h3>
                        <TextParser text={faq.question} />
                    </h3>
                    <p><img src={LogoIcon} alt="" className="destination__info__image"></img><TextParser text={faq.answer} /></p>
                </div>)
            })}
        </div>
        <hr className="w75" />
        <DestinationRecommendationCards
            title={similarWeatherHeader}
            month={pageContext.month}
            lazyLoad={true}
            locationsToShow={data.regionsMonthsJson.similar}
        />
        <div className="height--2" />
        {/* <SocialMediaShareButtons location={location.href}
                             media={destinationInfo.backgroundImage.publicURL}
                             title={'Počasí v ' + destinationInfo.czech.title}
                             quote={pageDescription}
    /> */}
        {/* <div className="destination__form">
            <h4 className="destination__form__heading">Pokročilý vyhledávač idální dovolené</h4>
            <div className="w100 center">
                <MainSearchForm />
            </div>
        </div> */}
    </Layout >)
}


interface Query {
    regionsJson?: Region,
    regionsMonthsJson?: RegionMonth
}





export const query = graphql`

query MyQuery($month: String, $slug: String, $testBuild: Boolean) {
    regionsJson(slug: { eq: $slug }, testBuild: { eq: $testBuild }) {
        ...RegionFull
        
    }
    regionsMonthsJson(month: { eq: $month }, slug: { eq: $slug }, testBuild: { eq: $testBuild }) {
        ...RegionMonth
    }
}
`


export default Location;